module.exports = __webpack_public_path__ + "static/media/room4green.ebe6e2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/room4green.png
// module id = 359
// module chunks = 0